import type { PaymentTerm, PlanTrial, SyncStatus } from '@vy/types';
import { PAYMENT_TERMS, TRIAL_DURATION_TYPES, SYNC_STATUSES } from '@vy/types';
import type { Optional } from '@vy/utils';
import { raiseUnreachable, isNotNullOrUndefined, vyDate } from '@vy/utils';
import { weeksToDays, monthsToDays, formatDate } from '../../../../../utils/date';

export function getPaymentTermLabel(paymentTerm: PaymentTerm) {
  switch (paymentTerm) {
    case PAYMENT_TERMS.Prepayment:
      return 'Pre Payment';
    case PAYMENT_TERMS.Postpayment:
      return 'Post Payment';
    default:
      return raiseUnreachable(paymentTerm);
  }
}

export function formatTrialDays(trial: PlanTrial) {
  const { duration, type } = trial;

  switch (type) {
    case TRIAL_DURATION_TYPES.Weeks:
      return weeksToDays(duration);
    case TRIAL_DURATION_TYPES.Months:
      return monthsToDays(duration);
    default:
      return raiseUnreachable(type);
  }
}

export function formatSyncStatus(contractSyncStatus: SyncStatus): string {
  switch (contractSyncStatus) {
    case SYNC_STATUSES.None:
      return 'Not synced';
    case SYNC_STATUSES.Synced:
      return 'Success';
    case SYNC_STATUSES.Failed:
      return 'Failed';
    default:
      return raiseUnreachable(contractSyncStatus);
  }
}

export function formatSyncStatusUpdatedAt(contractSyncStatusUpdatedAt: Optional<Date>): string {
  return isNotNullOrUndefined(contractSyncStatusUpdatedAt)
    ? formatDate(vyDate(contractSyncStatusUpdatedAt), 'MMM. D, YY')
    : '';
}
